import { ApplicationPayment, ApplicationPaymentRequest } from '@/types/application-payment';

import { RequestService } from '../services/request.service';

export const createPaymentRequest = async (applicationPayment: ApplicationPaymentRequest) => {
	const request = RequestService.getInstance();

	const { data } = await request.post<ApplicationPayment>(
		'/api_v1/applications_payment/create/',
		applicationPayment,
	);

	return data;
};
